/**
 * Especifica una root variable de css
 * @param variable
 * @param value
 */
export const setRootVariable = (variable: string, value: string) => {
  const root = document.querySelector(':root') as HTMLElement | null;
  if (root !== null) {
    root.style.setProperty(variable, value);
  }
};

/**
 * Obtiene un valor de los query params por su nombre
 * @param paramName - Nombre del parámetro a buscar en los query params
 * @returns El valor del parámetro o undefined si no existe
 */
export function getQueryParam(paramName: string): string | undefined {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(paramName) || undefined;
}
